export default __webpack_public_path__ + "static/media/full-cal-sugar-eq.637c73ee.png";